import React from 'react';

const CourierDriverRules = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Courier Driver Rules for XGO Life App</h1>
      <p className="mb-4">Last Updated: February 6, 2025</p>

      <h2 className="text-2xl font-semibold mt-6">Introduction</h2>
      <p className="mb-4">
        By adhering to these rules, courier drivers can ensure a safe, efficient, and professional delivery experience for all users of the Xgo Life App.
      </p>

      <h2 className="text-2xl font-semibold">1. Conduct and Professionalism</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Maintain a professional demeanor while interacting with customers and colleagues.</li>
        <li>Dress appropriately and wear any required identification or uniform.</li>
      </ul>

      <h2 className="text-2xl font-semibold">2. Safety and Compliance</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Adhere to all traffic laws and regulations while driving.</li>
        <li>Use safety equipment, such as seat belts and helmets where applicable.</li>
        <li>Report any accidents or incidents immediately to the management.</li>
      </ul>

      <h2 className="text-2xl font-semibold">3. Delivery Protocols</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Confirm delivery details, including addresses and customer contacts, before departure.</li>
        <li>Ensure packages are handled with care to prevent damage.</li>
        <li>Deliver items within the agreed time frame; communicate any delays promptly.</li>
      </ul>

      <h2 className="text-2xl font-semibold">4. Customer Interaction</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Communicate politely and professionally with customers.</li>
        <li>Verify the identity of customers before handing over deliveries.</li>
        <li>Address customer inquiries and concerns promptly.</li>
      </ul>

      <h2 className="text-2xl font-semibold">5. Use of App</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Use the Xgo Life App for all delivery tasks and updates.</li>
        <li>Keep the app updated to access the latest features and improvements.</li>
        <li>Report any technical issues with the app to support immediately.</li>
      </ul>

      <h2 className="text-2xl font-semibold">6. Confidentiality and Data Protection</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Respect the privacy of customers by not sharing their personal information.</li>
        <li>Handle all data in compliance with the Data Protection Policy of the app.</li>
      </ul>

      <h2 className="text-2xl font-semibold">7. Work Hours and Availability</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Adhere to the scheduled work hours and notify management of any changes in availability.</li>
        <li>Be punctual for all assigned deliveries.</li>
      </ul>

      <h2 className="text-2xl font-semibold">8. Performance and Accountability</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Maintain a high level of performance, including delivery accuracy and customer satisfaction.</li>
        <li>Be accountable for the packages in your possession until delivered.</li>
      </ul>

      <h2 className="text-2xl font-semibold">9. Prohibited Actions</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Do not engage in any form of harassment, discrimination, or inappropriate behavior.</li>
        <li>Avoid using the app while driving unless safely parked.</li>
      </ul>

      <h2 className="text-2xl font-semibold">10. Disciplinary Actions</h2>
      <p className="mb-4">
        Violation of these rules may result in disciplinary action, including termination of your contract with Xgo Life.
      </p>
    </div>
  );
};

export default CourierDriverRules;